import { useEffect, useState } from "react";
import { Product } from "../../../types/Shop";
import DB_PATH from "../../DB_PATH";
import { firestore } from "../../firebase";

type Options = {
  communityId?: string;
};

export const useAllProducts = ({ communityId }: Options = {}) => {
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    if (!communityId) {
      setProducts([]);
      return;
    }

    const productsRef = firestore
      .collection(DB_PATH.COMMUNITY)
      .doc(communityId)
      .collection("Shop")
      .doc("shop")
      .collection("products");

    const unsubscribe = productsRef.onSnapshot(
      (snapshot) => {
        const productsData = snapshot.docs.map((doc) => {
          const data = doc.data() as Product;
          return { ...data, id: doc.id };
        });

        // Sort by index
        productsData.sort((a, b) => (a.index || 0) - (b.index || 0));
        setProducts(productsData);
      },
      (error) => {
        console.error("Error fetching products", error);
        setProducts([]);
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return products;
};
